import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';

import { envConfig } from 'config';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_VIDEO_QUESTIONS';
export const single = 'SINGLE_VIDEO_QUESTION';

export const videoQuestionsApi = createApi({
  reducerPath: 'videoQuestionsApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    testVideoQuestion: builder.mutation({
      query: (args) => ({
        url: `${envConfig.streamLambdaUrl}/video-questions/test`,
        method: 'POST',
        body: {
          s3Key: args.s3Key,
          prompts: args.prompts
        }
      })
    }),
    createVideoQuestion: builder.mutation({
      query: (videoQuestion) => ({
        url: '/video-questions/create',
        method: 'POST',
        body: videoQuestion
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: created } = await queryFulfilled;
          dispatch(
            videoQuestionsApi.util.updateQueryData('listVideoQuestions', undefined, (draft) => {
              draft.data.items.unshift(created.data);
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    updateVideoQuestion: builder.mutation({
      query: ({ videoQuestionId, ...attributes }) => ({
        url: `/video-questions/update/${videoQuestionId}`,
        method: 'POST',
        body: { ...attributes }
      }),
      invalidatesTags: [single],
      async onQueryStarted({ videoQuestionId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled;
          dispatch(
            videoQuestionsApi.util.updateQueryData('listVideoQuestions', undefined, (draft) => {
              const item = draft.data.items.find((question) => question.id === videoQuestionId);
              if (item) {
                Object.assign(item, updated.data);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    deleteVideoQuestion: builder.mutation({
      query: (videoQuestionId) => ({
        url: `/video-questions/delete/${videoQuestionId}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            videoQuestionsApi.util.updateQueryData('listVideoQuestions', undefined, (draft) => {
              const idx = draft.data.items.findIndex((item) => item.id === id);
              if (idx > -1) {
                draft.data.items.splice(idx, 1);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    getVideoQuestionById: builder.query({
      query: (videoQuestionId) => `/video-questions/get/${videoQuestionId}`,
      providesTags: [single]
    }),
    listVideoQuestions: builder.query({
      query: (params) => ({
        url: '/video-questions/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    })
  })
});

export const {
  useTestVideoQuestionMutation,
  useCreateVideoQuestionMutation,
  useUpdateVideoQuestionMutation,
  useDeleteVideoQuestionMutation,
  useGetVideoQuestionByIdQuery,
  useListVideoQuestionsQuery
} = videoQuestionsApi;
